import { render, staticRenderFns } from "./ChatLayout.vue?vue&type=template&id=65935c03&scoped=true&"
import script from "./ChatLayout.vue?vue&type=script&lang=js&"
export * from "./ChatLayout.vue?vue&type=script&lang=js&"
import style0 from "./ChatLayout.vue?vue&type=style&index=0&id=65935c03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65935c03",
  null
  
)

export default component.exports